import { ApiClient } from "../config/axiosConfig";
import { INotification } from "../models/Notification";

interface GetNotificationsParams {
  page?: number;
  limit?: number;
}

export const notificationService = {
  getNotifications: async (
    params?: GetNotificationsParams
  ): Promise<INotification[]> => {
    const { page = 1, limit = 5 } = params || {};
    const res = await ApiClient.GET<INotification[]>(
      `/notifications?page=${page}&limit=${limit}`
    );
    return res;
  },
  readNotification: async (id: number) => {
    const res = await ApiClient.PUT(`/notifications/${id}/read`);
    return res;
  },
};
